import { defineMessages } from 'react-intl-next';

export const i18n: {
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'company-hub.hub-element-placeholder.manifest.extension-title',
		defaultMessage: 'Hub element placeholder',
		description:
			'Title of hub element placeholder extension to be displayed the macro is presented in the editor.',
	},
});
